import React from 'react';

import {
    useCurationConfigState
} from '../../../../hooks/widgetConfiguration.js';

import MetricLoadingView from '../../../../components/MetricLoadingView.jsx';
import useContentModal from '../../hooks/useContentModal.jsx';

import useListeningCurationFilterValues from '../../hooks/useListeningCurationFilterValues.js';

import ContextMenu from './ContextMenu.jsx';

import {
    RIQPopover
} from '../../../../components/RIQPopover.jsx';

import {
    useVerifySearch
} from '../../hooks/useVerifySearch.js';


function SuggestedKeywords({label, values, dimensionName, onClickInclude, onClickExclude, onSampleClick}) {

    return (
        <div className='tlw-bg-gray-100 tlw-p-10'>
            <div className='tlw-text-sm tlw-font-semibold tlw-uppercase tlw-text-gray-900'>{label}</div>
            <div className='tlw-mt-5'>

                {values.map((value, index) => {
                    return (
                        <RIQPopover
                            key={`${index}-${value}`}
                            className={`tlw-mb-3 tlw-mr-3 tlw-inline-flex tlw-h-12 tlw-items-center tlw-justify-center tlw-rounded-[15px] tlw-border-0 !tlw-bg-gray-800 tlw-px-3.5 tlw-py-0 tlw-text-white`}
                            triggerNode={<div>{value}</div>}
                            placement={'right'}
                        >
                            <ContextMenu
                                value={value}
                                valueName={dimensionName}
                                onClickInclude={onClickInclude}
                                onClickExclude={onClickExclude}
                                onSampleClick={onSampleClick}
                            />
                        </RIQPopover>
                    );
                })}
            </div>
        </div>
    );
}

const NUM_SUGGESTIONS_TO_SHOW = 10;
export default function FilterSuggestions({instanceId, inclusionsConfigKey, exclusionsConfigKey, dimension, dimensionName, label, resultToValue, measuresToRequest}) {

    const [inclusions, setInclusions] = useCurationConfigState(inclusionsConfigKey);
    const [exclusions, setExclusions] = useCurationConfigState(exclusionsConfigKey);
    const {showContentModal, ContentModal} = useContentModal(`filter-suggestions-${dimension}`);

    const {orderedErrors} = useVerifySearch(true);
    const hasValidationError = _.find(orderedErrors, {
        isFatal: true
    });

    const metricFilters = useListeningCurationFilterValues();
    metricFilters.listening.limit = NUM_SUGGESTIONS_TO_SHOW * 2;
    if (inclusionsConfigKey) {
        // If we have a set of inclusions, passing them to the metric request will cause the metric to return
        // only those values, which is not that helpful. We'll oversample to get more values to suggest.
        delete metricFilters.listening[inclusionsConfigKey];
    }
    const metricRequests = {};

    if (!hasValidationError) {
        _.each(measuresToRequest, measure => {
            metricRequests[measure.field || measure] = {
                dataSourceId: RivalIQ.metrics.new.enums.DataSourceIds.LISTENING_QUERY_SEARCH,
                dimensions: [dimension],
                measure: measure,
                filters: metricFilters
            };
        });
    }

    function onClickInclude(value) {
        setInclusions(_.union(inclusions, [value]));
    }

    function onClickExclude(value) {
        // This is mindbending but clicking "exclude" means we want to include that value in the set of exclusions.
        setExclusions(_.union(exclusions, [value]));
    }

    function onSampleClick(value) {
        showContentModal({
            [dimension]: [value]
        });
    }

    return (
        <div
            className='tlw-mx-8'
        >
            {!hasValidationError &&
                <MetricLoadingView
                    instanceId={instanceId}
                    metricRequests={metricRequests}
                >
                    {
                        (metricResults) => {
                            const collatedResults = RivalIQ.metrics.new.MetricResponse.groupResponsesByFixedDimensions(metricResults);

                            const existingFilterValues = {};
                            if (inclusionsConfigKey) {
                                _.extend(existingFilterValues, _.keyBy(inclusions, inclusion => inclusion.toLowerCase()));
                            }
                            if (exclusionsConfigKey) {
                                _.extend(existingFilterValues, _.keyBy(exclusions, exclusion => exclusion.toLowerCase()));
                            }

                            const values = _(collatedResults)
                                .map(resultToValue)
                                .compact()
                                .filter(value => !existingFilterValues[value.toLowerCase()])
                                .uniqBy(value => value.toLowerCase())
                                .take(NUM_SUGGESTIONS_TO_SHOW)
                                .value();

                            return (
                                <SuggestedKeywords
                                    label={label}
                                    values={values}
                                    dimensionName={dimensionName}
                                    onClickInclude={inclusionsConfigKey ? onClickInclude : null}
                                    onClickExclude={exclusionsConfigKey ? onClickExclude : null}
                                    onSampleClick={onSampleClick}
                                />
                            );
                        }
                    }
                </MetricLoadingView>
            }

            {ContentModal}
        </div>
    );
}
